export function EmptyState({ icon: Icon, title, description, action, testId = "empty-state" }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 sm:py-16 px-6" data-testid={testId}>
      {Icon && (
        <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-muted/60 border border-border">
          <Icon className="h-6 w-6 text-muted-foreground" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-heading font-semibold text-lg">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-muted-foreground max-w-md">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
